var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNmc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#186C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8343 13.2188L10.8349 13.2176C10.9216 13.2193 11.0082 13.2099 11.0925 13.1895C11.5852 13.0742 12.0021 12.6439 12.1011 12.1793L14.0625 4.81275L12.5033 4.80487L11.2174 9.62438L7.74113 4.78856L7.73888 4.79081L7.74056 4.78519L7.16625 4.78125V4.78181C7.07939 4.78047 6.99269 4.78973 6.90806 4.80938C6.41587 4.92525 5.99906 5.35556 5.8995 5.81962L3.9375 13.1878L5.49731 13.1946L6.78262 8.37506L10.2589 13.2114H10.2606L10.8343 13.2188ZM7.12575 7.09087L7.39744 6.07275L10.8743 10.9097L10.6026 11.9278L7.12631 7.09031L7.12575 7.09087Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmc);
export default __webpack_public_path__ + "static/media/nmc.0502ded9e013b8a30c3b85f3cb8012c1.svg";
export { ForwardRef as ReactComponent };